// extracted by mini-css-extract-plugin
export default {"root":"RlVJN","icon":"n04X3","active-icon":"_1QFm2","activeIcon":"_1QFm2"};